"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.HttpMethod = exports.ThenType = exports.ComputationOperator = exports.LogicalOperator = exports.ComparisonOperator = void 0;
var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator[ComparisonOperator["EQUALS"] = 0] = "EQUALS";
    ComparisonOperator[ComparisonOperator["NOT_EQUAL"] = 1] = "NOT_EQUAL";
    ComparisonOperator[ComparisonOperator["EMPTY"] = 10] = "EMPTY";
    ComparisonOperator[ComparisonOperator["NOT_EMPTY"] = 11] = "NOT_EMPTY";
    ComparisonOperator[ComparisonOperator["CONTAINS"] = 2] = "CONTAINS";
    ComparisonOperator[ComparisonOperator["NOT_CONTAIN"] = 3] = "NOT_CONTAIN";
    ComparisonOperator[ComparisonOperator["GREATER"] = 6] = "GREATER";
    ComparisonOperator[ComparisonOperator["LESS"] = 7] = "LESS";
    // OLD (useless)
    ComparisonOperator[ComparisonOperator["STARTS_WITH"] = 4] = "STARTS_WITH";
    ComparisonOperator[ComparisonOperator["ENDS_WITH"] = 5] = "ENDS_WITH";
    ComparisonOperator[ComparisonOperator["GREATER_OR_EQUAL"] = 8] = "GREATER_OR_EQUAL";
    ComparisonOperator[ComparisonOperator["LESS_OR_EQUAL"] = 9] = "LESS_OR_EQUAL";
})(ComparisonOperator = exports.ComparisonOperator || (exports.ComparisonOperator = {}));
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator[LogicalOperator["AND"] = 0] = "AND";
    LogicalOperator[LogicalOperator["OR"] = 1] = "OR";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
var ComputationOperator;
(function (ComputationOperator) {
    ComputationOperator["ADD"] = "Add";
    ComputationOperator["SUBTRACT"] = "Subtract";
    ComputationOperator["MULTIPLY"] = "Multiply";
    ComputationOperator["DIVIDE"] = "Divide";
})(ComputationOperator = exports.ComputationOperator || (exports.ComputationOperator = {}));
var ThenType;
(function (ThenType) {
    ThenType["JUMP"] = "jump";
    ThenType["COMPUTATION"] = "computation";
    ThenType["REDIRECT"] = "redirect";
    ThenType["HTTP"] = "http";
})(ThenType = exports.ThenType || (exports.ThenType = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["POST"] = "POST";
    HttpMethod["GET"] = "GET";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["HEAD"] = "HEAD";
    HttpMethod["CONNECT"] = "CONNECT";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["TRACE"] = "TRACE";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
var ContentType;
(function (ContentType) {
    ContentType["JSON"] = "JSON";
    ContentType["FORM_ENCODE"] = "x-www-form-urlencoded";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=conditions.js.map